<template>
	<div>
		<div class=" row">

			<div class="col-lg-2" v-for="(item, index) in items" :key="item.id">
				<div :class="{isActive : item.selected }" @click="selectAdditionalElement(item, index)">
					<img class="w100" :src="item.images" alt="">
					<p>{{ item.title }}</p>
				</div>
			</div>



		</div>
		<div class="row">
			<h3 id="s2" class="title-steps">+</h3>
			<div class="col-lg-12 section-work">
				<forms v-if="this.renderFormElements" @exportMeta="exportMeta" :formElements="formElements" @change="updateData()"></forms>
				
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Forms from './Forms'

	
	export default {
		name: 'soft-element',
	props: {
			for: {
				type: String,
				require: false,
				default:'module',
			}
		},
		data() {
			return {

				items: [],
				selectedItems: [],
				formElements: [],
				renderFormElements: false,
				formElements: [],
			}
		},
		
		created() {
			// alert(this.for)

			if(this.for == 'product') {
			this.importAdditionalElementProduct()

			} else {
			this.importAdditionalElementModule()

			}
		},
		methods: {
			exportMeta(data) {
				this.formElements = data
				this.updateData()

			},


				importAdditionalElementProduct() {

				if(this.$route.name == 'shop-product-edit') {
					axios.get(this.$store.getters.getDomainName+'soft/element/group/search/product/'+this.$route.params.id)
					.then(response => {
						this.formElements = response.data['formElements']
						this.items = response.data['formElementGroups']
						this.softElements = response.data['softElements']

						console.log(this.items)
						this.renderFormElements = true

						this.updateData()

					})
					.catch(error => {

					})

				}

				if(this.$route.name == 'shop-product-create') {

					axios.get(this.$store.getters.getDomainName+'soft/element/group')
					.then(response => {
						this.items = response.data

						console.log(this.items)


					})
					.catch(error => {

					})
				}
			},


			importAdditionalElementModule() {

				if(this.$route.name == 'soft-module-edit') {
					axios.get(this.$store.getters.getDomainName+'soft/element/group/search/module/'+this.$route.params.id)
					.then(response => {
						this.formElements = response.data['formElements']
						this.items = response.data['formElementGroups']
						this.softElements = response.data['softElements']

						console.log(this.items)
						this.renderFormElements = true

						this.updateData()

					})
					.catch(error => {

					})

				}

				if(this.$route.name == 'soft-module-create') {

					axios.get(this.$store.getters.getDomainName+'soft/element/group')
					.then(response => {
						this.items = response.data

						console.log(this.items)


					})
					.catch(error => {

					})
				}
			},
			selectAdditionalElement(item, index) {

				console.log(item)
				if(item.selected == false) {
					item.selected = true
					for (var i = 0; i < item.softelements.length; i++) {

						this.formElements.push({ 

							ids: item.softelements[i].id,
							id: i,
							type: 'input',
							name: item.softelements[i].title,
							placeholder: item.title + ' - ' +  item.softelements[i].title,
							model: '',
							item_id: item.id,
							readonly: true,
							selected: true
						})

					}

				} else {


					var formElements = this.formElements.reverse()

					// this.formElements.forEach(this.myFunction)


					for (var j = this.formElements.length - 1; j >= 0; j--) {

						if(this.formElements[j].item_id == item.id) {

							console.log(this.formElements.name)

							item.selected = false

								// item.softelements[i].selected = false
								this.formElements.splice(j, 1)

							}
						}
						item.selected = false

					}




				this.renderFormElements = true

			},

			myFunction(item, index, arr) {
				alert(index)
				alert(item.name)
				this.formElements.splice(index, 1)

			},
			updateData() {
				this.$emit('exportElements', this.formElements);

			}

		},
		components: {
			Forms
		}


	}

</script>

<style>
.isActive {
	border: 1px solid blue;
}
</style>


// WEBPACK FOOTER //
// src/components/app_modules/SoftElement.vue